module.exports = __webpack_public_path__ + "img/product-sm-2.2a611510.png";